import React from 'react';
import {connect} from 'react-redux';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {getFlatActiveTeammates} from '../../../libs/shared/core/src/store/data/teammates/commonTeammatesSelectors';
import {AuditTrailPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapStateToProps} from '../../../srcCommon/helpers/reselectHelpers';
import {getFlatInboxes} from '../../store/data/inboxes/inboxesSelectors';
import {AuditTrailFiltersMenu} from './auditTrailFiltersMenu';

/*
 * Props.
 */

interface AuditTrailMenuContainerProps {
  panelId: AuditTrailPanelId;
}

/*
 * Redux.
 */

function getActivities() {
  return [
    {id: 'commented', name: () => <Trans id="audit-trail-filters-commented">Commented</Trans>},
    {id: 'assigned', name: () => <Trans id="audit-trail-filters-assigned">Assigned</Trans>},
    {id: 'archived', name: () => <Trans id="audit-trail-filters-archived">Archived</Trans>},
    {id: 'outbound', name: () => <Trans id="audit-trail-filters-outbound">Sent</Trans>},
    {id: 'inbound', name: () => <Trans id="audit-trail-filters-inbound">Received</Trans>},
    {id: 'deleted', name: () => <Trans id="audit-trail-filters-deleted">Deleted</Trans>},
  ];
}

const mapStateToProps = makeMapStateToProps<AuditTrailMenuContainerProps>()(() => ({
  activities: getActivities,
  inboxes: getFlatInboxes,
  teammates: getFlatActiveTeammates,
}));

export const AuditTrailFiltersMenuContainer = connect(mapStateToProps)(AuditTrailFiltersMenu);
